"use client";

;
import ContentsCard from "@/reusablecomponents/TableOfContents";
import "./page.scss";
import VideoDetailCard from "@/reusablecomponents/VideoCourseCard";
import Button from "@/uicomponents/Button";
import { projectImages } from "public/Assets/Images";
import ReviewerSection from "@/reusablecomponents/ReviewerSection";
import TypoGraphy from "@/typography";
import useViewType from "@/utils/Hooks/useViewType";
import AbsoluteModal from "@/reusablecomponents/Modals/AbsoluteModal";
import { useContext, useEffect, useRef, useState } from "react";
import MentorDetails from "@/reusablecomponents/MentorDetails";
import { RouteStrings } from "@/utils/routestrings";
import FaqSection from "@/reusablecomponents/FaqSection";
import { useParams, useRouter } from "next/navigation";
import { getSlugAndRouteName, handleVettedClick } from "@/utils/Functions";
import CardSection from "@/reusablecomponents/CardSection";
import ReviewerDetails from "@/reusablecomponents/ReviewerDetails";
import MarkdownRenderer from "@/reusablecomponents/MarkdownRenderer";
import MobileModal from "@/reusablecomponents/Modals/MobileModal";
import { AppContext } from "@/contexts/appcontext";
import MobileFilter from "@/uicomponents/MobileFilter";
import { formatDateNormal } from "@/utils/Functions/formatDate";
import PlusReviewerImage from "@/reusablecomponents/PlusReviewersImage";
import { SubTopic } from "../Topic";
import { extractTableOfContents } from "@/utils/Functions/extractTOC";
import { API_ENDPOINTS } from "@/services/endPoints";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
const ArticlePage = ({
  coursesData,
  topicData,
  highlightedCourse,
  nextSchedule,
  temp,
  topicIndustryData,
  filteredSubIndustries
}: any) => {
  const isMobile = useViewType();
  const [shareModal, setshareModal] = useState(false);
  const [fbhover, setfbhover] = useState(false);
  const [linkedinHover, setlinkedinHover] = useState(false);
  const [twitterHover, settwitterHover] = useState(false);
  const {
    setArticle,
    setSubTopic,
    setTopic
  } = useContext<any>(AppContext);
  const {
    updateSchemaData
  } = useContext<any>(AppContext);
  const {
    push
  } = useRouter();
  const {
    setCourse,
    showBreadCrumbModal,
    setshowBreadCrumbModal,
    showBreadCrumbDesktopModal,
    setshowBreadCrumbDesktopModal,
    selectedTimeZone,
    slug
  } = useContext<any>(AppContext);
  const params = useParams();
  const {
    routeId
  } = getSlugAndRouteName(params?.route?.toString() || '');
  const findTopicById = (id: number): any | undefined => {
    for (const topic of temp) {
      for (const subtopic of topic.attributes.subTopics) {
        const foundArticle = subtopic.articles.data.find((article: any) => article.id === id);
        if (foundArticle) {
          return {
            data: [topic]
          };
        }
      }
    }
    return {};
  };
  const coursessData = topicIndustryData?.data?.reduce((a: {
    freecourses: Array<any>;
    premCourses: Array<any>;
  }, b: any) => {
    if (b.attributes.isPremium) {
      a.premCourses.push(b);
    } else {
      a.freecourses.push(b);
    }
    return a;
  }, {
    freecourses: [],
    premCourses: []
  });
  if (!topicData) {
    topicData = routeId ? findTopicById(routeId) : {};
  }
  const mentorRef = useRef<any>(null);
  const curiculumRef = useRef<any>(null);
  const handlePrevClick = () => {
    if (currentArticleIndex > 0) {
      push(RouteStrings.DYNAMICROUTE(topicData.data[0].attributes.subTopics[currentSubtopicIndex].articles.data[currentArticleIndex - 1].attributes.title.replace(/\W/g, '-'), 'ARTICLE', topicData.data[0].attributes.subTopics[currentSubtopicIndex].articles.data[currentArticleIndex - 1].id));
    }
  };
  const handleNextClick = () => {
    const currentSubtopic = topicData.data[0].attributes.subTopics[currentSubtopicIndex];
    if (currentArticleIndex < currentSubtopic.articles.data.length - 1) {
      push(RouteStrings.DYNAMICROUTE(topicData.data[0].attributes.subTopics[currentSubtopicIndex].articles.data[currentArticleIndex + 1].attributes.title.replace(/\W/g, '-'), 'ARTICLE', topicData.data[0].attributes.subTopics[currentSubtopicIndex].articles.data[currentArticleIndex + 1].id));
    }
  };
  const foundArticleData = topicData.data[0].attributes.subTopics.reduce((result: any, subTopic: any, subTopicIndex: number) => {
    if (result) return result;
    const articleIndex = subTopic.articles.data.findIndex((article: any) => article.id === routeId);
    if (articleIndex !== -1) {
      return {
        article: subTopic.articles.data[articleIndex],
        subTopicIndex: subTopicIndex,
        articleIndex: articleIndex
      };
    }
    return null;
  }, null);
  const {
    article,
    subTopicIndex,
    articleIndex
  } = foundArticleData;
  const subTopic = topicData?.data[0]?.attributes?.subTopics.find((subtopic: any) => {
    for (let i of subtopic.articles.data) {
      if (i.id === article.id) {
        return subtopic;
      }
    }
  });
  useEffect(() => {
    setArticle(article.attributes.title);
    setSubTopic(subTopic?.subTopicName);
    setTopic(topicData?.data[0]?.attributes?.topicName);
    const handleBodyClick = (e: any) => {
      const classNames = ['D_B_1_R_16_160', 'bread_crumb_items_wrapper', 'share_images', 'icon_image'];
      if (classNames.includes(e.target.className)) return;
      setshareModal(false);
      setshowBreadCrumbDesktopModal(false);
    };
    document.body.addEventListener('click', handleBodyClick);
    return () => {
      setshowBreadCrumbDesktopModal(false);
      setshowBreadCrumbModal(false);
      document.body.removeEventListener('click', handleBodyClick);
    };
  }, []);
  const currentSubtopicIndex = subTopicIndex;
  const currentArticleIndex = articleIndex;
  const subTopicLength = topicData.data[0].attributes.subTopics[currentSubtopicIndex].articles.data.length;
  const omitSubtopicId = topicData.data[0].attributes.subTopics[subTopicIndex].id;
  const slicedReviewersImages = article.attributes.reviewedBy.data;
  const toc = extractTableOfContents(article.attributes.articleContent);
  const markdownWithAnchors = article.attributes.articleContent;
  const formattedDate = formatDateNormal(article.attributes.updatedAt);
  const subTopics = topicData?.data[0].attributes.subTopics;
  const filteredSubTopics = subTopics.filter((subtopic: any) => {
    return subtopic.id !== parseInt(omitSubtopicId);
  });
  const currentURL = typeof window !== 'undefined' ? window.location.href : '';
  const articleRef = useRef<HTMLDivElement>(null);
  const padding = 20;
  const mouseEntered = useRef(false);
  const handleDownloadPDF = () => {
    const articleElement = articleRef.current;
    if (!articleElement) return;
    const pdf = new jsPDF('p', 'pt', 'a4', true);
    const articleHeight = articleElement.scrollHeight;
    let currentPosition = 0;
    const chunkSize = 1100;
    const captureNextChunk = () => {
      const remainingHeight = articleHeight - currentPosition;
      const chunkHeight = Math.min(chunkSize, remainingHeight);
      html2canvas(articleElement, {
        height: chunkHeight,
        y: currentPosition
      }).then(canvas => {
        const imgData = canvas.toDataURL('image/png');

        // Calculate aspect ratio of the captured content
        const aspectRatio = canvas.width / canvas.height;

        // Calculate width and height considering padding and aspect ratio
        const width = pdf.internal.pageSize.width - 2 * padding;
        const height = width / aspectRatio;
        pdf.addImage(imgData, 'PNG', padding,
        // Left padding
        padding,
        // Top padding
        width, height, '', 'FAST');
        currentPosition += chunkHeight;
        if (currentPosition < articleHeight) {
          pdf.addPage();
          captureNextChunk();
        } else {
          pdf.save(`${article.attributes.title}.pdf`);
        }
      });
    };
    captureNextChunk();
  };
  function generateJsonLdMarkup(article: any): any {
    const jsonLDSchema = {
      "@context": "https://schema.org",
      "@type": "Article",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": `${API_ENDPOINTS.APP_SERVER_URL}/${article.attributes.title.toLowerCase()?.replace(/\W/g, '-')}-article-${article.id}`
      },
      "headline": article.attributes.title,
      "description": article.attributes.shortDescription,
      "image": article.attributes.thumbnail.data?.attributes.url,
      "datePublished": article.attributes.publishedAt,
      "dateModified": article.attributes.updatedAt,
      "url": `${API_ENDPOINTS.APP_SERVER_URL}/${article.attributes.title.toLowerCase()?.replace(/\W/g, '-')}-article-${article.id}`,
      "author": article.attributes.mentors.data.map((author: any) => ({
        "@type": "Person",
        "name": author.attributes.name,
        "image": author.attributes.mentorImageUrl,
        "jobTitle": author.attributes.designation
      })),
      "publisher": {
        "@type": "Organization",
        "name": "GrowthSchool"
      },
      "inLanguage": "en-IN"
    };
    return jsonLDSchema;
  }
  const handleMouseLeave = (e: any) => {
    setTimeout(() => {
      if (!mouseEntered.current) {
        setshareModal(false);
        setfbhover(false);
        setlinkedinHover(false);
        settwitterHover(false);
      }
    }, 500);
  };
  useEffect(() => {
    if (article) updateSchemaData(generateJsonLdMarkup(article));
    document.title = `${article?.attributes?.title} | GrowthSchool`;
  }, [article]);
  return <>
      <div className="breadcrumb_relative">
        {showBreadCrumbDesktopModal && !isMobile && <AbsoluteModal left={'30px'} top={'5px'} onMouseEnter={() => setshowBreadCrumbDesktopModal(true)} onMouseLeave={() => setshowBreadCrumbDesktopModal(false)}>
          <div className="bread_crumb_items_wrapper">
            <TypoGraphy variant='Desktop/Body 1/R | 16 |160' text='Learn' clickHandler={() => push(RouteStrings.TOPICSINDEX)} styles={{
            minWidth: "fit-content"
          }} />
            <TypoGraphy variant='Desktop/Body 1/R | 16 |160' text={topicData?.data[0]?.attributes?.topicName} clickHandler={() => push(RouteStrings.DYNAMICROUTE(topicData?.data[0]?.attributes?.topicName.replace(/\s+/g, "-").replace(/-+/g, "-"), 'TOPICDETAIL', topicData?.data[0]?.id))} styles={{
            minWidth: "fit-content"
          }} />
            <TypoGraphy variant='Desktop/Body 1/R | 16 |160' text={subTopic?.subTopicName} clickHandler={() => push(RouteStrings.DYNAMICROUTE(subTopic?.subTopicName.replace(/\s+/g, "-").replace(/-+/g, "-"), 'SUBTOPIC', subTopic?.id))} styles={{
            minWidth: "fit-content"
          }} />
          </div>
        </AbsoluteModal>}
      </div>
      <div className="article_page_wrapper">
        <div id="article-content" className="article_content">
          <div className="left_content_wrapper">
            <div ref={articleRef}>
              <div className="article_header_content">
                <div className="header_content">
                  <div className="title_wrapper">
                    <TypoGraphy text={article.attributes.title} variant={isMobile ? "Mobile/Heading" : "Desktop/Heading 2"} tagName="h1" data-sentry-element="TypoGraphy" data-sentry-source-file="page.tsx" />
                    <TypoGraphy text={`Last updated on ${formattedDate} • ${article.attributes.minuteRead} min read`} variant={!isMobile ? 'Desktop/Body 2/R | 14 |120' : 'Desktop/Caption/R | 12 |120'} styles={!isMobile ? {
                    paddingTop: "8px",
                    color: '#030a21',
                    opacity: '60%'
                  } : {
                    paddingTop: "12px",
                    paddingBottom: "24px",
                    color: '#030a21',
                    opacity: '60%'
                  }} data-sentry-element="TypoGraphy" data-sentry-source-file="page.tsx" />
                  </div>

                  {isMobile && article.attributes.mentors.data.map((mentor: any, index: number) => {
                  return <div className="mentor_detail_list" key={`men_${index}`}>
                      <MentorDetails mentorImageUrl={mentor.attributes.mentorImageUrl} name={mentor.attributes.name} designation={mentor.attributes.designation} companyName={mentor.attributes.companyName} />
                    </div>;
                })}
                  {!isMobile ? <div className="share_icon_wrapper">
                      <div className="share_icon_wrapper" onMouseEnter={() => {
                    if (!isMobile) setshareModal(true);
                  }} onMouseLeave={handleMouseLeave} onClick={() => {
                    if (!isMobile || !navigator) return;
                    navigator.share({
                      url: encodeURIComponent(currentURL)
                    });
                  }}>
                        <img src={shareModal ? projectImages.shareHover : projectImages.shareIconFilled} alt="share" />
                        {shareModal && <AbsoluteModal top={"50px"} right={"0"} onMouseEnter={() => mouseEntered.current = true} onMouseLeave={() => mouseEntered.current = false} styles={{
                      boxShadow: "0px 75px 21px 0px rgba(0, 0, 0, 0.00), 0px 48px 19px 0px rgba(0, 0, 0, 0.01), 0px 27px 16px 0px rgba(0, 0, 0, 0.05), 0px 3px 7px 0px rgba(0, 0, 0, 0.10)"
                    }}>
                            <div className="share_images">
                              <img className='icon_image' src={fbhover ? projectImages.fbDark : projectImages.facebook} onMouseEnter={() => setfbhover(true)} onMouseLeave={() => setfbhover(false)} onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentURL)}`, '_blank')} alt="facebook" />
                              <img className='icon_image' src={linkedinHover ? projectImages.linkedinDark : projectImages.linkedin} onMouseEnter={() => setlinkedinHover(true)} onMouseLeave={() => setlinkedinHover(false)} onClick={() => window.open(`https://www.linkedin.com/shareArticle?url=${encodeURIComponent(currentURL)}`, '_blank')} alt="linkedin" />
                              <img className='icon_image' src={twitterHover ? projectImages.twitterDark : projectImages.twitter} onMouseEnter={() => settwitterHover(true)} onMouseLeave={() => settwitterHover(false)} onClick={() => window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(currentURL)}`, '_blank')} alt="twitter" />
                            </div>
                          </AbsoluteModal>}
                      </div>
                    </div> : <div className="mobile_share_button" onClick={() => {
                  if (!isMobile || !navigator) return;
                  navigator.share({
                    url: encodeURIComponent(currentURL)
                  });
                }}>
                      <TypoGraphy text="Share" variant="Mobile/Body 2/R | 14 | 160" />
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M9.05178 11.5118L5.64511 9.65379C5.31811 9.97839 4.90232 10.1989 4.45017 10.2875C3.99802 10.3762 3.52975 10.329 3.10439 10.1519C2.67904 9.97475 2.31564 9.67567 2.06001 9.29233C1.80438 8.90899 1.66797 8.45855 1.66797 7.99779C1.66797 7.53704 1.80438 7.0866 2.06001 6.70326C2.31564 6.31992 2.67904 6.02084 3.10439 5.84373C3.52975 5.66662 3.99802 5.61941 4.45017 5.70804C4.90232 5.79668 5.31811 6.0172 5.64511 6.34179L9.05178 4.48379C8.93494 3.93562 9.01933 3.3637 9.28951 2.87263C9.55969 2.38156 9.9976 2.00415 10.5232 1.80942C11.0487 1.61469 11.6269 1.61564 12.1518 1.81212C12.6767 2.00859 13.1134 2.38745 13.3819 2.87942C13.6505 3.37139 13.733 3.94358 13.6143 4.49136C13.4956 5.03915 13.1838 5.52592 12.7357 5.86266C12.2877 6.1994 11.7334 6.36361 11.1742 6.32526C10.615 6.28691 10.0883 6.04856 9.69044 5.65379L6.28378 7.51179C6.35164 7.83202 6.35164 8.16291 6.28378 8.48313L9.69044 10.3418C10.0883 9.94703 10.615 9.70868 11.1742 9.67033C11.7334 9.63198 12.2877 9.79619 12.7357 10.1329C13.1838 10.4697 13.4956 10.9564 13.6143 11.5042C13.733 12.052 13.6505 12.6242 13.3819 13.1162C13.1134 13.6081 12.6767 13.987 12.1518 14.1835C11.6269 14.3799 11.0487 14.3809 10.5232 14.1862C9.9976 13.9914 9.55969 13.614 9.28951 13.123C9.01933 12.6319 8.93494 12.06 9.05178 11.5118Z" fill="#030A21" />
                      </svg>
                    </div>}

                </div>
                <TypoGraphy text={article.attributes.shortDescription} variant={isMobile ? "Mobile/Body 2" : "Desktop/Body 1/R | 16 |160"} styles={{
                paddingTop: "16px",
                paddingBottom: "24px",
                fontSize: !isMobile ? "20px" : "",
                fontWeight: !isMobile ? "400" : "",
                lineHeight: !isMobile ? "150%" : ""
              }} data-sentry-element="TypoGraphy" data-sentry-source-file="page.tsx" />

              </div>

              {!isMobile && article?.attributes?.reviewedBy?.data?.length > 0 && <div className="images_wrapper">
                <div className="mentors_images_section">
                  {slicedReviewersImages.map((image: any, index: number) => {
                  return <div className="rounded_absolute_image" style={index > 0 ? {
                    marginLeft: "-10px"
                  } : {}} key={`reviewer_${index}`}>
                        <img src={image.attributes.mentorImageUrl} alt="mentor" />
                      </div>;
                })}
                  {slicedReviewersImages.length > 3 && <div className="rounded_absolute_image" style={{
                  marginLeft: "-10px"
                }}>
                    <PlusReviewerImage count={slicedReviewersImages.length} />
                  </div>}
                </div>
                <img src={projectImages.createText} alt="created" onClick={() => handleVettedClick(mentorRef.current)} style={{
                cursor: "pointer"
              }} />
              </div>}

              {article.attributes.thumbnail.data?.attributes.url && <div className="thumnbail_wrapper">
                <img className="thumnbail_image" src={article.attributes.thumbnail.data?.attributes.url}></img>
              </div>}

              {isMobile && <div className="video_card_inline" style={{
              background: "rgba(3, 10, 33, 0.03)"
            }}>
                <TypoGraphy variant='Condensed/Mobile/Heading 1 | M | 24 | 140' text="Learn Via Video Course"></TypoGraphy>
                <VideoDetailCard data={highlightedCourse} nextSchedule={nextSchedule}></VideoDetailCard>
              </div>}

              <MarkdownRenderer content={markdownWithAnchors} data-sentry-element="MarkdownRenderer" data-sentry-source-file="page.tsx"></MarkdownRenderer>

              {article.attributes.mentors.data?.length > 0 && <div className="mentor_section_wrapper">
                <TypoGraphy tagName='h4' text={"Written by"} variant={isMobile ? "Condensed/Mobile/Heading 1 | M | 24 | 140" : 'Desktop/Body 1/M | 16 |120'} />
                {article.attributes.mentors.data.map((mentor: any, index: number) => {
                return <div className="mentor_detail_list" key={`mentorList_${index}`}>
                    <MentorDetails mentorImageUrl={mentor.attributes.mentorImageUrl} name={mentor.attributes.name} designation={mentor.attributes.designation} companyName={mentor.attributes.companyName} />
                    <TypoGraphy text={mentor.attributes.aboutMentor} variant={isMobile ? "Mobile/Body 2" : "Desktop/Body 1/R | 16 |160"} styles={{
                    paddingTop: "8px"
                  }} />
                  </div>;
              })}
              </div>}

              {article?.attributes?.reviewedBy?.data?.length > 0 && <div className="reviewer_section">
                <TypoGraphy tagName='h4' text={"Reviewed by "} variant={isMobile ? "Condensed/Mobile/Heading 1 | M | 24 | 140" : 'Desktop/Body 1/M | 16 |120'} />
                {article?.attributes?.reviewedBy?.data?.map((item: any, index: number) => <div className={`reviewer_${index}`}><ReviewerDetails name={item.attributes.name} companyName={item.attributes.companyName} designation={item.attributes.designation} reviewerImage={item.attributes.mentorImageUrl}></ReviewerDetails></div>)}
              </div>}
            </div>
            {/* Pagination */}
            <div className="pagination_wrapper">
              {<div onClick={() => handlePrevClick()} className={`pagination_button ${articleIndex === 0 ? 'disabled' : ''}`}>
                <>
                  {articleIndex !== 0 ? <><img className='normal' src={projectImages.paginationdark} alt="left" style={{
                    transform: "rotate(180deg)"
                  }} /> <img className='hover' src={projectImages.paginationArrowRightLight} alt="left" style={{
                    transform: "rotate(180deg)"
                  }} /> </> : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                    <path d="M6.38086 12.5469L2.33419 8.50021L6.38086 4.45354" stroke="#030A21" strokeOpacity="0.2" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M13.668 8.5H2.44797" stroke="#030A21" strokeOpacity="0.2" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>}
                  <TypoGraphy color={`${articleIndex !== 0 ? 'black' : 'grey'}`} variant={isMobile ? 'Mobile/Body 2/R | 14 | 160' : 'Desktop/Body 1/R | 16 |120'} text='Previous' tagName='a' />
                </>
              </div>}
              <div onClick={() => handleNextClick()} className={`pagination_button ${articleIndex !== topicData.data[0].attributes.subTopics[currentSubtopicIndex].articles.data.length - 1 ? '' : 'disabled'}`}>
                <TypoGraphy color={`${articleIndex !== subTopicLength - 1 ? 'black' : 'grey'}`} variant={isMobile ? 'Mobile/Body 2/R | 14 | 160' : 'Desktop/Body 1/R | 16 |120'} text='Next' tagName='a' data-sentry-element="TypoGraphy" data-sentry-source-file="page.tsx" />
                <>
                  {articleIndex === subTopicLength - 1 ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                    <path d="M9.61914 4.45312L13.6658 8.49979L9.61914 12.5465" stroke="#030A21" strokeOpacity="0.2" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M2.33203 8.5H13.552" stroke="#030A21" strokeOpacity="0.2" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                  </svg> : <><img className='normal' src={projectImages.paginationdark} alt="right" />
                      <img className='hover' src={projectImages.paginationArrowRightLight} alt="right" /></>}
                </>
              </div>
            </div>

            {filteredSubTopics?.length > 0 && <div className="subtopic_wrapper" ref={curiculumRef}>
              <div className="subtopic_heading">
                <TypoGraphy text={"Continue Learning"} variant={isMobile ? "Condensed/Mobile/Heading 1 | M | 24 | 140" : "Condensed/Desktop/Heading 1 | M | 32 | 140"} />
              </div>
              <div className="subtopic_list_wrapper">
                {filteredSubTopics.map((subtopic: any, index: number) => {
                return <div className="" key={`sub_topic_${index}`}>
                      <SubTopic subTopic={subtopic} index={index} />
                    </div>;
              })}
              </div>
            </div>}
            {article?.attributes?.reviewedBy?.data?.length > 0 && <div className="reviewer_sec" ref={mentorRef}>
              <ReviewerSection data={article.attributes.reviewedBy.data ?? ""} title="Vetted by Industry Experts"></ReviewerSection>
            </div>}
          </div>
          {article.attributes.articleFaq && <FaqSection data={article.attributes.articleFaq} />}
        </div>

        {!isMobile && <div className="article_sidebar" style={{
        display: "flex",
        flexDirection: "column",
        gap: "24px"
      }}>
          <ContentsCard headings={toc}></ContentsCard>
          <VideoDetailCard data={highlightedCourse} nextSchedule={nextSchedule}></VideoDetailCard>
          <div className="buttons_wrapper">
            <Button text="Download PDF" variant="ArticleVariant" textVariant="Desktop/Body 1/M | 16 |160" textColor="#000000" image={projectImages.downloadIconOutlined} styles={{
            cursor: "pointer"
          }} imageWidth={20} imageHeight={20} clickHandler={handleDownloadPDF}></Button>
            <Button text="Topics" variant="ArticleVariant" textVariant="Desktop/Body 1/M | 16 |160" textColor="#000000" image={projectImages.squaresOutlined} styles={{
            cursor: "pointer"
          }} imageWidth={20} imageHeight={20} clickHandler={() => handleVettedClick(curiculumRef.current ? curiculumRef.current : 0)}></Button>
          </div>
        </div>}
      </div>
      <div className="topics_card_section" style={{
      marginTop: isMobile ? "40px" : ""
    }}>
        <CardSection data={{
        cards: coursessData?.premCourses,
        filters: filteredSubIndustries
      }} isFilterArray industryName={topicData.data[0].attributes.industry.data.attributes.industryName} title={"Related Premium " + topicData.data[0].attributes.industry.data.attributes.industryName + "Courses"} styles={{
        background: isMobile ? "white" : ""
      }} data-sentry-element="CardSection" data-sentry-source-file="page.tsx" />
                <CardSection data={{
        cards: coursessData?.freecourses,
        filters: filteredSubIndustries
      }} isFilterArray industryName={topicData.data[0].attributes.industry.data.attributes.industryName} title={"Related Free " + topicData.data[0].attributes.industry.data.attributes.industryName + " Certification Courses"} data-sentry-element="CardSection" data-sentry-source-file="page.tsx" />
      </div>
      {showBreadCrumbModal && isMobile && <MobileModal closehandler={() => setshowBreadCrumbModal(false)}>
        <div className="bread_crumb_items_wrapper">
          <TypoGraphy variant='Desktop/Body 1/R | 16 |160' text='Learn' clickHandler={() => push(RouteStrings.TOPICSINDEX)} />
          <TypoGraphy variant='Desktop/Body 1/R | 16 |160' text={topicData?.data[0]?.attributes?.topicName} clickHandler={() => push(RouteStrings.DYNAMICROUTE(topicData?.data[0]?.attributes?.topicName.replace(/\s+/g, "-").replace(/-+/g, "-"), 'TOPICDETAIL', topicData?.data[0]?.id))} />
          <TypoGraphy variant='Desktop/Body 1/R | 16 |160' text={subTopic?.subTopicName} clickHandler={() => push(RouteStrings.DYNAMICROUTE(subTopic?.subTopicName.replace(/\s+/g, "-").replace(/-+/g, "-"), 'SUBTOPIC', subTopic?.id))} />
        </div>
      </MobileModal>}
      <MobileFilter data={topicData} toc={toc} videoCardData={highlightedCourse} nextSchedule={nextSchedule} articleData={article} articleRef={articleRef} data-sentry-element="MobileFilter" data-sentry-source-file="page.tsx" />
    </>;
};
export default ArticlePage;